export default {"src":"/_next/static/image/public/images/flags/flag_687.54ebdbf89a10b33c9f9f8466cb7e8e97.svg","height":16,"width":24};